/**
 * 详情页关于不同场景mixins
 */

import { mapGetters, mapActions } from "vuex"
import * as gameProps from "@api/gameProps"
import * as url from "@utils/url"
import * as reportDict from "@constants/report-dictonary"
import * as userApi from "@api/user"
import { checkFilterStoreConfigBiz } from "@api/store-config"

export default {
  data() {
    return {}
  },

  computed: {
    ...mapGetters(["currentItem", "userAgent", "pfSource"]),
    // 外部场景，比如主播带货场景，控制Detail页模块展示
    isOuterScene() {
      return gameProps.isOuterScene()
    },
    isDialogMode() {
      return gameProps.isDialogMode()
    },
    showServiceZoneIcon() {
      // JSAPI调用模式 && 该业务有专区 && 该业务在商店没有做屏蔽
      return (
        this.isDialogMode &&
        this.currentItem?.newServiceZone == 1 &&
        !checkFilterStoreConfigBiz(this.currentItem) &&
        !url.getParam("disableHomeIcon")
      )
    },
    isAnchorOuterScene() {
      return gameProps.isAnchorOuterScene()
    },
    apiModeAdsImg() {
      let adsImg = ""
      if (this.isDialogMode) {
        let matchConfig = gameProps.handleConfigBySource({ config: this.currentItem.apiModeAds, pfSource: this.pfSource })

        matchConfig?.adsImg?.split(";").forEach(ads => {
          let adsConfig = url.getParams(ads, true)
          if (adsConfig && adsConfig.img && gameProps.checkTimeValid(adsConfig.onlineTime, adsConfig.offlineTime)) {
            adsImg = adsConfig.img
          }
        })
      }
      return adsImg
    }
  },

  methods: {
    ...mapActions(["reportUserAction"]),

    // 导航栏前往专区页
    goToServiceZone() {
      this.reportUserAction({
        iformat: reportDict.CLICK.DETAIL_OUTER_NAV_ZONE
      })

      let zoneUrl = `https://pay.qq.com/h5/shop.shtml?pf=XXX&hash=${encodeURIComponent(
        `/order/${this.currentItem.groupId}/biz/${this.currentItem.busId}?serviceZone=1`
      )}`

      if (this.userAgent.QQ || (this.userAgent.weixin && !this.userAgent.weixinminiprogram)) {
        parent?.postMessage &&
          parent.postMessage(
            {
              action: "redirect",
              url: zoneUrl
            },
            "*"
          )
      } else {
        // getOpenlink 拉起
        this.currentItem?.ams?.offerid &&
          userApi
            .getOpenlink(
              {
                offerId: this.currentItem.ams.offerid
              },
              {
                url: zoneUrl,
                match_mode: 1
              }
            )
            .then(res => {
              res?.info?.openlink &&
                parent?.postMessage &&
                parent.postMessage(
                  {
                    action: "redirect",
                    url: zoneUrl
                  },
                  "*"
                )
            })
            .catch(e => {
              this.reportUserAction({
                iformat: reportDict.ERROR.SHOP_GET_OPENLINK,
                resultInfo: e
              })
            })
      }
    },

    // 关闭详情页模块
    closeDetailDialog() {
      parent?.postMessage &&
        parent.postMessage(
          {
            action: "close"
          },
          "*"
        )
    }
  }
}
